// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"0e91226f","682":"d3e8680e"}[chunkId] + ".chunk.css";
};